import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

import { getUserProfileLocal } from '../../core/helpers'

const { helpers: { getLoginFromMail, getUserId } } = core

const { theirRole, decision } = commonConfigValues

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const supervisionFrequency = [
  { id: 1, label: 'Every 4 Weeks' },
  { id: 2, label: 'Every 6 Weeks' },
  { id: 3, label: 'Every 8 Weeks' }
]

export const valueTable = { supervisionFrequency }

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'personnel.ui',
      'personnel.fullName',
      'supervision.supervisorName',
      'supervision.theirRole',
      'supervision.supervisionContractDate',
      'supervision.frequency',
      'supervision.supervisionDate',
      'supervision.flag',
      'supervision.annualFlag'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.ui',
    title: 'Staff Member Personel No. (UI)',
    minSpace: 'Personel No. (UI) ',
    formField: true
  },
  {
    name: 'register.firstName',
    title: 'SM First Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.lastName',
    title: 'SM Last Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.fullName',
    title: 'Staff Member Name',
    formField: true,
    getCellValue: row =>
      `${row['register.firstName'] || ''} ${row['register.lastName'] || ''}`,
    maxChars: 100,
    minSpace: 'Staff Member '
  },

  {
    name: 'supervision.supervisorName',
    title: 'Supervisor Name',
    formField: true,
    type: 'select',
    // getCellValue: row =>
    //   _.find(users, ['id', parseInt(row[`supervision.supervisorName`], 10)])
    //     ? _.find(users, ['id', parseInt(row[`supervision.supervisorName`], 10)]).label
    //     : row[`supervision.supervisorName`],
    options: 'users',
    filterField: true,
    minSpace: 'Supervisor '
  },
  {
    //AUTO CALCULATED BASED ON SUPERVISOR
    name: 'supervision.theirRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`supervision.theirRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`supervision.theirRole`], 10)])
            .label
        : row[`supervision.theirRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'supervision.supervisionContractDate',
    title: 'Supervision Contract Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Contract Date '
  },
  {
    name: 'supervision.frequency',
    title: 'Supervision Frequency Minimum',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`supervision.frequency`], 10)])
        ? _.find(decision, ['id', parseInt(row[`supervision.frequency`], 10)])
            .label
        : row[`supervision.frequency`],
    options: 'decision',
    filterField: true,
    minSpace: 'Freqency Minimum '
  },
  {
    name: 'supervision.contractOnFile',
    title: 'Supervision Contract on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(supervisionFrequency, [
        'id',
        parseInt(row[`supervision.contractOnFile`], 10)
      ])
        ? _.find(supervisionFrequency, [
            'id',
            parseInt(row[`supervision.contractOnFile`], 10)
          ]).label
        : row[`supervision.contractOnFile`],
    options: 'supervisionFrequency',
    filterField: true,
    minSpace: 'Contract on File? '
  },
  {
    name: 'supervision.contractSigned',
    title: 'Supervision Contract Signed by both Parties?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`supervision.contractSigned`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`supervision.contractSigned`], 10)
          ]).label
        : row[`supervision.contractSigned`],
    options: 'decision',
    filterField: true,
    minSpace: 'Signed by both Parties? '
  },
  {
    name: 'supervision.supervisionDate',
    title: 'Supervision Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Supervision '
  },
  {
    //auto calculated
    name: 'supervision.sessionNo',
    title: 'Supervision Session No. this Calendar Year',
    formField: true,
    // getCellValue: row =>
    // filterField: true,
    minSpace: 'Supervision Session No. '
  },
  {
    //auto calculated
    name: 'supervision.sessionRequired',
    title: 'No. of Supervision Sessions Required at this point in Year',
    formField: true,
    // getCellValue: row =>
    // filterField: true,
    minSpace: 'Required at this point in Year '
  },
  {
    name: 'supervision.recordOnFile',
    title: 'Supervision Records on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`supervision.recordOnFile`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`supervision.recordOnFile`], 10)
          ]).label
        : row[`supervision.recordOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Records on File? '
  },
  {
    name: 'supervision.recordSigned',
    title: 'Supervision Record Signed by both Parties?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`supervision.recordSigned`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`supervision.recordSigned`], 10)
          ]).label
        : row[`supervision.recordSigned`],
    options: 'decision',
    filterField: true,
    minSpace: 'Signed by both Parties? '
  },
  {
    //auto calculated
    name: 'supervision.flag',
    title: 'Supervision Flag',
    formField: true,
    // getCellValue: row =>
    filterField: true,
    minSpace: 'Supervision '
  },
  {
    //hidden in LEVEL 2
    //auto calculated
    name: 'supervision.annualFlag',
    title: 'Supervision Annual Flag',
    formField: true,
    // getCellValue: row =>
    filterField: true,
    minSpace: 'Supervision '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'supervision',
      historyName: 'supervisionHistory',
      label: 'Personnel',
      icon: 'note',
      fields: [
        {
          //DISABLED FOR LEVEL1
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Personnel Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'sup',
      activeName: 'supervision',
      historyName: 'supervisionHistory',
      label: 'Supervision',
      icon: 'note',
      fields: [
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.supervisorName',
            disabled: !add,
            label: 'Supervisor Name',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.register.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            })
            //change their role after manipulate field
          },
          {
            //AUTO POPULATE BASED ON SELECTED SUPERVISOR

            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.theirRole',
            label: 'Their Role',
            disabled: true,
            required: showAsterix,
            // validate: v => (v ? undefined : 'Field is required'),
            options: theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.supervisionContractDate',
            label: 'Supervision Contract Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },

          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.frequency',
            label: 'Supervision Frequency Minimum',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.supervisionFrequency
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.contractOnFile',
            label: 'Supervision Contract on File?',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.contractSigned',
            label: 'Supervision Contract Signed by both Parties?',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],

        //##############################################
        //MUITABLE FOR ENTER DATES AND ADDITIONAL INFO
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.supervisionDate',
            label: 'Supervision Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            //FIELD FROM PERSONNEL sheet (not PERSONNEL Level 2)
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            disabled: true,
            hidden: getUserProfileLocal().role === 'Level 2',
            name: 'supervision.sessionNo',
            label: 'Supervision Session No. this Calendar Year'
          },
          {
            //FIELD FROM PERSONNEL sheet (not PERSONNEL Level 2)
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            disabled: true,
            hidden: getUserProfileLocal().role === 'Level 2',
            name: 'supervision.sessionRequired',
            label: 'No. of Supervision Sessions Required at this point inYear'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.recordOnFile',
            label: 'Supervision Record on File?',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'supervision.recordSigned',
            label: 'Supervision Record Signed by both Parties?',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          name: 'supervision.flag',
          label:
            getUserProfileLocal().role === 'Level 2'
              ? 'Supervision Flag '
              : 'Supervision Flag - Next Session'
        },
        {
          //FIELD FROM PERSONNEL sheet (not PERSONNEL Level 2)
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          name: 'supervision.annualFlag',
          label: 'Supervision Flag - Annual Requirment',
          hidden: getUserProfileLocal().role === 'Level 2'
        }
        //##############################################
      ]
    }
  ]

  return forms
}

export const activeSection = ['supervision']

export const errors = [1, 2]

export const defaultNew = {
  supervision: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  supervisionHistory: []
}

// "supervisions": [
//   {
//   "id": 1,
//   "registerId": 1,
// "supervision": {
//  "supervisorName": 2
//  "supervisionContractDate": "2001-01-01T23:28:56.782Z"
//  "frequency": 2,
// "contractOnFile": 1,
// "contractSigned": 1,
//  "supervisionDate": "2001-01-01T23:28:56.782Z",
// "recordOnFile": 1,
// "recordSigned": 1,
//  "flag": "amber",
//  "annualFlag":"amber"
// },
// "supervisionHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/personnel/configs/supervisions.js